import { Box, Button, NoticeBox, Text } from '@factorialco/deprecated-design-system'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

const NonBlockingBanner = ({ days }: { days: number | null }) => {
  const { canManageSubscription } = useCurrentSession()
  const { navigation } = useNavigation()

  return (
    <NoticeBox
      message={
        <Box gap="s4" flexDirection="row" justifyContent="center" alignItems="center">
          <Text.Normal color="grey1000" weight="semibold">
            {canManageSubscription
              ? i18n.t('billing.unpaid_invoices.non_blocking_banner.title')
              : i18n.t('billing.unpaid_invoices.non_blocking_banner.employee_title')}
          </Text.Normal>
          <Text.Normal color="grey1000">
            {canManageSubscription
              ? i18n.t('billing.unpaid_invoices.non_blocking_banner.description', { days })
              : i18n.t('billing.unpaid_invoices.non_blocking_banner.employee_description', {
                  days,
                })}
          </Text.Normal>
          {canManageSubscription && (
            <Button.Router to={navigation.settings.plans.fullPath()} type="primary">
              {i18n.t('billing.unpaid_invoices.non_blocking_banner.cta')}
            </Button.Router>
          )}
        </Box>
      }
      justifyContent="center"
    />
  )
}

export default NonBlockingBanner
